import React from 'react'

const PhysicalHealthIcon = ({ fillColor, size }) => (
  <svg width={size} height={size} viewBox='0 0 36 36'>
    <defs>
      <path
        d='M20 6.28571429h-5.7142857V.57142857C14.2857143.2558373 14.029877 0 13.7142857 0H6.85714286c-.31559129 0-.57142857.25583729-.57142857.57142857V6.2857143H.57142857C.2558373 6.28571429 0 6.54155157 0 6.85714286v6.85714284c0 .3155913.25583729.5714286.57142857.5714286H6.2857143V20c0 .3155913.25583728.5714286.57142857.5714286h6.85714284c.3155913 0 .5714286-.2558373.5714286-.5714286v-5.7142857H20c.3155913 0 .5714286-.2558373.5714286-.5714286V6.85714286c0-.31559129-.2558373-.57142857-.5714286-.57142857zm-.5714286 6.85714281h-6.2857143v6.2857143H7.42857143v-6.2857143H1.14285714V7.42857143h6.28571429V1.14285714h5.71428567v6.28571429h6.2857143v5.71428567z'
        id='cphysical'
      />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(-93 -609)'>
        <g transform='translate(100.714286 616.714286)'>
          <mask id='dphysical' fill='#fff'>
            <use xlinkHref='#cphysical' />
          </mask>
          <use fill={fillColor || '#000'} fillRule='nonzero' xlinkHref='#cphysical' />
          <g mask='url(#dphysical)' fill={fillColor || '#000'}>
            <path d='M-5.714286-5.714286h32v32h-32z' />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default PhysicalHealthIcon
